export default __webpack_public_path__ + "images/5b6c401a52070a2947357122fbcdaf11.svg";